import { array, enumerated, object, string } from '~/prix'

export const googleMapsInteractionFields = {
  mapProvider: enumerated({
    none: 'none',
    google_maps: 'google_maps',
    mapbox: 'mapbox',
    apple_maps: 'apple_maps',
    openstreetmap: 'openstreetmap',
    other: 'other',
  }).isOptional(),
  sessionToken: string().isOptional(),
}

export const googlePlacesStatus = enumerated({
  available: 'available',
  not_eligible: 'not_eligible',
  disabled: 'disabled',
  quota_exceeded: 'quota_exceeded',
  unavailable: 'unavailable',
  invalid_input: 'invalid_input',
  invalid_response: 'invalid_response',
  not_found: 'not_found',
})

export const googlePlacesPresentationFields = {
  source: string(),
  placeId: string(),
  types: array(string()),
  attributions: array(object({ provider: string(), providerUri: string() })),
  presentation: object({
    attribution: string(),
    allowedMapProviders: array(string()),
    storage: string(),
  }),
}
